import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AnimatePresence } from 'framer-motion';

import RetroFreeDrawing from './components/RetroFreeDrawing';
import RetroSpeedClicker from './components/RetroSpeedClicker';
import RetroPrecisionClicker from './components/RetroPrecisionClicker';
import RetroPixelChallenge from './components/RetroPixelChallenge';
import RetroColorBubbles from './components/RetroColorBubbles';
import RetroPixelDrawer from './components/RetroPixelDrawer';
import RetroLetterCatcher from './components/RetroLetterCatcher';
import RetroFallingLetters from './components/RetroFallingLetters';
import AppContent from './components/AppContent';
import ImageGrid from './components/ImageGrid';
import ImageGridWithGames from './components/ImageGridWithGames';
import AdminDashboard from './pages/AdminDashboard';
// import PromptCraft from './pages/PromptCraft'; // Commented out - file not committed
// import PromptCraftTest from './components/PromptCraftTest'; // Commented out - file not committed
import Usage from './pages/Usage';
import Gallery from './pages/Gallery';
import ImageView from './pages/ImageView';



const USE_GAMES_VERSION = true;

function App() {
  const GridComponent = USE_GAMES_VERSION ? ImageGridWithGames : ImageGrid;



  return (
    <Router>
      <div className="min-h-screen">
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: '#363636',
              color: '#fff',
              fontFamily: 'VT323',
              fontSize: '16px'
            },
          }}
        />
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/retro-arcade" element={<Navigate to="/admin/retro-arcade" replace />} />
            <Route path="/free-drawing" element={<RetroFreeDrawing />} />
            <Route path="/speed-clicker" element={<RetroSpeedClicker />} />
            <Route path="/precision-clicker" element={<RetroPrecisionClicker />} />
            <Route path="/pixel-challenge" element={<RetroPixelChallenge />} />
            <Route path="/color-bubbles" element={<RetroColorBubbles />} />
            <Route path="/pixel-drawer" element={<RetroPixelDrawer />} />
            <Route path="/letter-catcher" element={<RetroLetterCatcher />} />
            <Route path="/retro-falling" element={<RetroFallingLetters />} />
            <Route path="/admin/*" element={
              <AppContent isFounderOnly={true}>
                <AdminDashboard />
              </AppContent>
            } />
            <Route path="/bs" element={<Navigate to="/admin" replace />} />
            <Route path="/logo-creator" element={<Navigate to="/admin/logo-creator" replace />} />
            {/* <Route path="/prompt-craft" element={<PromptCraft />} /> */}
            {/* <Route path="/prompt-craft-test" element={<PromptCraftTest />} /> */}
            <Route path="/usage" element={
              <AppContent>
                <Usage />
              </AppContent>
            } />
            <Route path="/gallery" element={
              <AppContent isPublicRoute={true}>
                <Gallery />
              </AppContent>
            } />
            <Route path="/image/:imageId" element={
              <ImageView />
            } />

            <Route path="/*" element={<AppContent GridComponent={GridComponent} />} />
          </Routes>
        </AnimatePresence>
      </div>
    </Router>
  );
}

export default App;